export const environment = {
  production: false,
  env: 'hom',
  apiBaseUrl: '/api/log/v3',
  apiBaseUrlV2: '/api/log/v2',
  reprocessBaseUrl: '/api/reprocess',
  // RHSSO Authorization Code + PKCE (login de usuário)
  iamLoginUrl: 'https://hom-iam.sascar.com.br/auth/realms/backoffice/protocol/openid-connect/auth',
  iamClientId: 'hom-int-monitor-integrations',
  iamRedirectUri: 'https://hom-protheus-integrations-monitor.app.sascar.com.br/iam/login',
  rhssoEnabled: true
};
